export interface ICRDSSite {
  name: string;
  id: number;
}

export class CRDSSite implements ICRDSSite {
  name: string;
  id: number;

  constructor(name: string, id: number) {
    this.name = name;
    this.id = id;
  }
}
